import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59d115d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=59d115d6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d115d6",
  null
  
)

export default component.exports